import React from 'react'
import { getLocale } from '@/lib/i18n'
import { privacyContent } from '@/locales/privacy'

interface PrivacyPolicyProps {
  onClose: () => void
}

export const PrivacyPolicy: React.FC<PrivacyPolicyProps> = ({ onClose }) => {
  const locale = getLocale()
  const content = privacyContent[locale] || privacyContent.en

  return (
    <div className="r3c-privacy-policy">
      <div className="r3c-privacy-policy__header">
        <h2 className="r3c-privacy-policy__title">{content.title}</h2>
        <button
          className="r3c-privacy-policy__close"
          onClick={onClose}
          aria-label="Close privacy policy"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
      <div className="r3c-privacy-policy__body">
        <p className="r3c-privacy-policy__updated">{content.lastUpdated}</p>
        {content.sections.map((section: { title: string; content: string }, index: number) => (
          <div key={index} className="r3c-privacy-policy__section">
            <h3 className="r3c-privacy-policy__section-title">{section.title}</h3>
            <p className="r3c-privacy-policy__section-content">{section.content}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
